import { render, staticRenderFns } from "./VerifyPopup.vue?vue&type=template&id=6722b858&scoped=true&"
import script from "./VerifyPopup.vue?vue&type=script&lang=js&"
export * from "./VerifyPopup.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPopup.vue?vue&type=style&index=0&id=6722b858&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722b858",
  null
  
)

export default component.exports